namespace Application.Common {
    'use strict';

    export var PROMISE_PENDING: number = 0;
    export var PROMISE_FULFILLED: number = 1;
    export var PROMISE_REJECTED: number = 2;
}